var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',_vm._b({attrs:{"type":"date","maxlength":"10","max":"9999-12-31","value":_vm.value,"error-messages":_vm.errorMessages},on:{"input":_vm.handleDateInput,"paste":_vm.handleDatePaste}},'v-text-field',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }